<template>
  <div style="width:100%; margin-top:150px">
    <div style="margin-top:50px">
      <span class="title"
            style="white-space: nowrap">{{title}}</span>

    </div>

    <div style="margin-top:100px; display:flex; justify-content:center">
      <div>
        <el-table :data="tabledata.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                  style="max-width:1250px;"
                  cell-style="color:black"
                  :header-cell-style="{background:'#eee',color:'black'}">
          <el-table-column prop="name"
                           label="应用名称"
                           width="290">

          </el-table-column>
          <el-table-column prop="description"
                           label="功能描述"
                           width="300">

          </el-table-column>
          <el-table-column prop="developerDetail"
                           label="开发者信息"
                           width="300">

          </el-table-column>
          <el-table-column prop="privilegeDetail"
                           label="权限列表"
                           width="300">

          </el-table-column>

        </el-table>
      </div>

    </div>

    <div style="margin-top:100px">
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[30, 50, 100]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="tabledata.length">
      </el-pagination>

    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import * as api from "../api/apt";

export default defineComponent({
  data() {
    return {
      tabledata: [],
      pageSize: 30,
      currentPage: 1,
      title: "",
    };
  },

  methods: {
    getPreApp(id) {
      // if(sessionStorage.getItem('category') != null){
      //     let category = sessionStorage.getItem('category')
      //     api.getPresetApp(category)
      // }

      api.getPresetApp(id).then((res) => {
        // console.log(res)
        this.tabledata = res.data.result.results;
        // console.log(this.tabledata)
      });
    },

    handleSizeChange(val) {
      this.pageSize = val;
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
    },
  },

  mounted() {
    let id = sessionStorage.getItem("category");
    let title = sessionStorage.getItem("title");
    if (title) {
      this.title = title;
    }
    this.getPreApp(id);
    // console.log(sessionStorage.getItem('category'))
  },
});
</script>

<style scoped>
.title {
  font-size: 40px;
  font-style: SourceHanSansSC-bold;
  font-weight: bold;
  color: black;
}

:deep() .el-table td {
  font-size: 16px;
  font-style: SourceHanSansSC-regular;
  text-align: left;
}

:deep() .el-table tr {
  font-size: 20px;
  font-style: SourceHanSansSC-regular;
  text-align: left;
}
</style>
